<template>
  <n-config-provider :locale="zhCN" :date-locale="dateZhCN">
    <n-message-provider>
      <div class="public-layout">
        <router-view />
      </div>
    </n-message-provider>
  </n-config-provider>
</template>

<script setup lang="ts">
import { NMessageProvider, NConfigProvider, zhCN, dateZhCN } from 'naive-ui'
</script>

<style scoped>
.public-layout {
  min-height: 100vh;
  background: #f5f7fa;
}
</style>
